var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabTape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 46,
    viewBox: "0 -30 69 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0001 12.3929C69.0001 19.2373 53.5538 24.7857 34.5003 24.7857C15.4469 24.7857 0.000610352 19.2373 0.000610352 12.3929C0.000610352 5.54843 15.4469 0 34.5003 0C53.5538 0 69.0001 5.54843 69.0001 12.3929Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8852 26.1941L49.4428 27.4059C48.5601 27.8441 48.5601 28.8099 49.4428 29.248L52.8595 30.9423C53.7469 31.3822 53.7469 32.3524 52.8595 32.7924L49.4226 34.4973C48.5495 34.9302 48.5495 35.8862 49.4226 36.3191L52.9012 38.0452C53.7684 38.4745 53.7684 39.4235 52.9012 39.8528L49.362 41.6091C48.5173 42.0277 48.5173 42.9519 49.362 43.3706L51.8769 44.6179C52.7299 45.0411 52.3267 46.0307 51.3011 46.0307H34.4997C15.4463 46.0307 0 40.4823 0 33.6378V12.3928C0 19.2372 15.4463 24.7857 34.4997 24.7857H51.3117C52.3349 24.7857 52.7358 25.7718 51.8852 26.1941Z",
    fill: "#ECE8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5002 24.7857H51.3123C52.3342 24.7857 52.7351 25.7718 51.8857 26.1941L49.4433 27.405C48.5594 27.8432 48.5594 28.809 49.4433 29.2471L52.86 30.9423C53.7464 31.3822 53.7464 32.3524 52.86 32.7924L49.4231 34.4973C48.55 34.9302 48.55 35.8862 49.4231 36.319L52.9017 38.0452C53.7689 38.4745 53.7689 39.4235 52.9017 39.8528L49.3625 41.6091C48.5178 42.0277 48.5178 42.9519 49.3625 43.3706L51.4848 44.4231C61.9394 42.2943 69 38.2639 69 33.6378V12.3928C69 19.2372 53.5535 24.7857 34.5002 24.7857Z",
    fill: "#C9C6B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5863 12.3928C47.5863 14.8369 41.7273 16.8189 34.5002 16.8189C27.2732 16.8189 21.4141 14.8369 21.4141 12.3928C21.4141 9.94877 27.2731 7.9668 34.5001 7.9668C41.7271 7.9668 47.5863 9.94877 47.5863 12.3928Z",
    fill: "#7D7B73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTape);
export default __webpack_public_path__ + "static/media/lab-tape.6f541fd60f7ffcd9f262bc908dec0558.svg";
export { ForwardRef as ReactComponent };